export default __webpack_public_path__ + "static/media/kabish.a6e51b2d.jpg";